import {useEffect, useState} from 'react';
import {EarlyAccessApplication} from '../../models/IRegistration';

const key = 'mybake:application-draft';

export function useApplicationDraft(empty: EarlyAccessApplication) {
    const [form, setForm] = useState(() => {
        try {
            const stored = sessionStorage.getItem(key);
            if (stored) {
                const draft = JSON.parse(stored);
                if (typeof draft.name === 'string' && typeof draft.email === 'string' && Array.isArray(draft.currentTools) && Array.isArray(draft.problems)) return {...empty, ...draft} as EarlyAccessApplication;
            }
        } catch {}
        return empty;
    });
    useEffect(() => {
        try { sessionStorage.setItem(key, JSON.stringify(form)); } catch {}
    }, [form]);
    const clear = () => { try { sessionStorage.removeItem(key); } catch {} };
    return {form, setForm, clear};
}
